// @flow
import type { GroupModel } from "../grouping/GroupingModel";

import ListHref from "../href/ListHref";

/**
 */
class SortOptionModel {
  _key: string;
  _label: string;
  _group: ?GroupModel;
  _sortorder: "desc" | "asc" = "desc";
  _selected: boolean = false;

  /**
   */
  constructor(key: string, label?: string, group?: ?GroupModel) {
    this._key = key;
    this._group = group;

    if (label) {
      this._label = label;
    } else if (group) {
      const attribute = group.getAttributeByKey(key);
      if (attribute) {
        this._label = attribute.label;
      }
    }
  }

  /**
   */
  reset() {
    this.selected = false;
    this.sortorder = "desc";
  }

  /**
   */
  get selected(): boolean {
    return this._selected;
  }

  /**
   */
  set selected(selected: boolean) {
    this._selected = selected;
  }

  /**
   */
  get key(): string {
    return this._key;
  }

  /**
   */
  get value(): string {
    return `${this.key} ${this.sortorder}`;
  }

  /**
   */
  get oppositeDirection(): "asc" | "desc" {
    return this.sortorder === "desc" ? "asc" : "desc";
  }

  /**
   */
  get oppositeValue(): string {
    return `${this.key} ${this.oppositeDirection}`;
  }

  /**
   */
  get label(): string {
    return this._label;
  }

  /**
   */
  get sortorder(): "desc" | "asc" {
    return this._sortorder;
  }

  /**
   */
  set sortorder(sortorder: "desc" | "asc") {
    this._sortorder = sortorder;
  }

  /**
   */
  get group(): ?GroupModel {
    return this._group;
  }

  /**
   */
  getHref(listHref: ListHref): ListHref {
    const listhref = new ListHref(listHref);
    const hasPage = listhref.prefix
      ? listhref.hasParameter("page", listhref.prefix)
      : listhref.hasParameter("page");
    if (hasPage) {
      listhref.page = 1;
    }
    listhref.sort = this.oppositeValue;

    return listhref;
  }
}

export default SortOptionModel;
